export default class ProjectEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#project_uuid") ? (elem.querySelector("#project_uuid") as HTMLInputElement).value : null,
            name: (elem.querySelector("#project_name") as HTMLInputElement).value,
            customer_id: elem.querySelector("#project_customer_id") ? (elem.querySelector("#project_customer_id option:checked") as HTMLInputElement).value : (elem.querySelector("#new_project_customer_id option:checked") as HTMLInputElement).value,
        }
    }
}